<template>
  <div class="bg-grey full-height">
    <div id="tab1" class="t-color-gray2 pdb-32">
      <div
        class="t-helper t-color-content1 pdt-16 pdb-8 pdl-16 pdr-16 l-spacing36 list-item-border-2 list-title-item"
      >
        {{ $t("1747") }}
      </div>
      <div class="bg-white pdl-16 pdr-16 pdt-11 pdr-11">
        <div class="list-item-border-2">
          <div class="t-body3 t-color-content1 l-spacing42">{{ $t("1748") }}</div>
          <div class="t-body3 t-color-title l-spacing42 pdb-11">    
            {{ (personalInfo && personalInfo.name)? personalInfo.name.last + ' ' + personalInfo.name.first:''}}
          </div>
        </div>
      </div>
      <div class="bg-white pdl-16 pdr-16 pdt-11 pdr-11">
        <div
          class="list-item-border-2 d-flex justify-content-between"
          @click="openPattenDialog"
        >
          <div>
            <div class="t-body3 t-color-content1 l-spacing42">
              {{ $t("1749") }}
            </div>
            <div
              class="t-body3 t-color-red3 l-spacing42 pdb-11"
              @click="openPattenDialog"
            >
              {{ $t("1750") }}
            </div>
          </div>
          <div
            v-if="profileImage"
            class="w-40 h-40 object-fit-cover"
            style="border-radius: 50%; overflow: hidden"
          >
            <img
              :src="personalInfo ? personalInfo.profile : ''"
              alt
              class="w-40 h-40 object-fit-cover"
            />
          </div>
          <div v-else>
            <img src="/images/ic_account.png" alt class="w-40 h-40 object-fit-cover" />
          </div>
        </div>
        <div class="pdr-16 pdt-11 pdr-11">
          <div class="t-body3 t-color-content1 l-spacing42">
            {{ $t("1751") }}
          </div>
          <div class="t-body3 t-color-title l-spacing42 pdb-11">
            {{ personalInfo ? personalInfo.userId : "" }}
          </div>
          <div class="last-list-item-border" />
        </div>
      </div>
      <div
        class="t-helper t-color-content1 pdt-32 pdb-8 pdl-16 pdr-16 l-spacing36 list-item-border-2 list-title-item"
      >
        {{ $t("1754") }}
      </div>
      <div class="bg-white pdl-16 pdr-16">
        <div class="pdr-16 pdt-11 pdr-11 list-item-border-2">
          <div class="t-body3 t-color-content1 l-spacing42">
            {{ $t("1755") }}
          </div>
          <div class="t-body3 t-color-title l-spacing42 pdb-11">
            {{ personalInfo ? personalInfo.dutyName : "" }}
          </div>
        </div>
        <div class="pdr-16 pdt-11 pdr-11 list-item-border-2">
          <div class="t-body3 t-color-content1 l-spacing42">
            {{ $t("1756") }}
          </div>
          <div class="t-body3 t-color-title l-spacing42 pdb-11">
            {{ personalInfo ? personalInfo.responsibilityName : "" }}
          </div>
        </div>
        <div class="pdr-16 pdt-11 pdr-11">
          <div class="t-body3 t-color-content1 l-spacing42">
            {{ $t("1757") }}
          </div>
          <div class="t-body3 t-color-title l-spacing42 pdb-11">
            {{ personalInfo ? personalInfo.storeName : "" }}
          </div>
          <div class="last-list-item-border" />
        </div>
      </div>
      <div class="t-helper t-color-content1 pdt-32 pdb-8 pdl-16 pdr-16 l-spacing36 list-item-border-2 list-title-item">
        {{ $t("S10059") }}
      </div>
      <div class="bg-white pdl-16 pdr-16" @click="goToAccountWithdrawal">
        <div class="pdr-16 pdt-11 pdr-11">
          <div class="t-body3 t-color-content1 l-spacing42">
            {{ $t("S10070") }}
          </div>
          <div class="t-body3 t-color-red3 l-spacing42 pdb-11">
            {{ $t("S10071") }}
          </div>
          <div class="last-list-item-border" />
        </div>
      </div>
    </div>

    <div class="mdc-dialog">
      <div class="mdc-dialog__container">
        <div class="mdc-dialog__surface">
          <h2 class="mdc-dialog__title">
            {{ $t("272") }}
            <!-- 프로필 유형 -->
          </h2>
          <div class="mdc-dialog__content">
            <ul class="mdc-list mdc-list--avatar-list">
              <li class="mdc-list-item" tabindex="0">
                <router-link class="text-title" to="/member/profilePicture">
                  <span class="mdc-list-item__text">
                    {{ $t("273") }}
                    <!-- 엘범에서 사진 선택 -->
                  </span>
                </router-link>
              </li>
              <!-- <li class="mdc-list-item">
                                <span class="mdc-list-item__text">
                                    {{$t('274')}}
                                    카메라로 쵤영
                                </span>
              </li>-->
              <li class="mdc-list-item">
                <router-link class="text-title" to="/member/profilePatten">
                  <span class="mdc-list-item__text">
                    {{ $t("275") }}
                    <!-- 패턴으로 등록 -->
                  </span>
                </router-link>
              </li>
            </ul>
          </div>
          <footer class="mdc-dialog__actions">
            <button
              type="button"
              class="mdc-button mdc-dialog__button btn-white"
              data-mdc-dialog-action="no"
            >
              <span class="mdc-button__label">
                {{ $t("276") }}
                <!-- 닫기 -->
              </span>
            </button>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Components/Mixin/Extend/API define
import { MDCDialog } from "@material/dialog";
import memberApi from "@/api/memberApi.js";

export default {
  name: "MemberDetail",
  
  data() {
    return {
      personalInfo: null,
      profileImage: null,
      phoneNo: null,
    };
  },

  mounted() {
    this.fatchData();
    this.pattenDialog = new MDCDialog(document.querySelector(".mdc-dialog"));
    this.pattenDialog.listen("MDCDialog:opened", () => {});
  },

  methods: {
    fatchData() {
      memberApi.getMemberInfo().then((response) => {
        this.personalInfo = response.data.data;
        this.profileImage = this.personalInfo ? this.personalInfo.profile : "";
        this.phoneNo = this.personalInfo ? this.personalInfo.phone : "";
      });
    },

    goToAccountWithdrawal() {
      this.$router.push({
        name: "Withdrawal",
      });
    },

    openPattenDialog() {
      this.pattenDialog.open();
    },

    addMobileNo() {
      this.$router.push("myphone");
    },
  },
};
</script>

<style scoped>
.bg-grey {
  background: #f9f9f9;
}
.nav-extended .brand-logo,
.nav-content * {
  font-family: noto-regular;
}
.nav-extended .brand-logo {
  font-size: 20px;
}
.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}
.tabs .indicator {
  background: #2d6dcc;
}
.mdc-elevation--z3 {
  border-radius: 4px;

  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}
.tabs .tab {
  width: 50%;
}
.list-item-border-2 {
  border-bottom: 1px solid #e6eced;
  background-color: #fff;
}
.list-item-border {
  border-bottom: 1px solid #e6eced;
}
.collapsible {
  border-top: none;
  border-right: none;
  border-left: none;
  margin: 0;
  box-shadow: none;
}
.collapsible-header {
  padding: 0;
  border-bottom: none;
}
.collapsible-header i {
  margin-right: 0;
}
.list-title-item {
  background-color: #f9f9f9;
}
.last-list-item-border {
  border-bottom: 1px solid #e6eced;
  width: 110vw;
  margin-left: calc(-50vw + 50%);
}
.full-height {
  height: 100vh;
}
</style>